//#region src/customer_state.ts
var CustomerState = /* @__PURE__ */ function(CustomerState) {
	CustomerState[CustomerState["Unverified"] = 0] = "Unverified";
	CustomerState[CustomerState["Enabled"] = 1] = "Enabled";
	CustomerState[CustomerState["Disabled"] = 2] = "Disabled";
	CustomerState[CustomerState["Deleted"] = 3] = "Deleted";
	return CustomerState;
}(CustomerState || {});
//#endregion
export { CustomerState };

//# sourceMappingURL=customer_state.js.map